import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './InfoButton.scss';

const InfoButton = ({ className = '', onClick, ...rest }) => (
    <CustomButton
        action='link'
        onClick={onClick}
        className={getClassName(styles['link-info-tool'], className)}
        {...rest}
    >
        <div className={styles['info-icon']} />
    </CustomButton>
);

export default InfoButton;
